import { defineComponent as R, useSlots as T, useAttrs as E, ref as v, computed as p, inject as S, onMounted as A, onUnmounted as M, watch as b, openBlock as y, createElementBlock as L, normalizeClass as U, unref as n, createVNode as $, withCtx as j, renderSlot as O, createBlock as q, createCommentVNode as h, toDisplayString as G, withDirectives as H, vModelRadio as J } from "vue";
import { ListSymbol as K, SplitButtonListSymbol as Q, getListItemStyleClasses as W } from "./novoui-vuejs57.js";
import X from "./novoui-vuejs30.js";
import Y from "./novoui-vuejs2.js";
import { CustomSelectListSymbol as Z } from "./novoui-vuejs62.js";
const ee = ["tabindex"], te = {
  key: 1,
  class: "list-item-type-label"
}, le = ["name", "value"], oe = /* @__PURE__ */ R({
  __name: "NListItem",
  props: {
    leadingIcon: { default: void 0 },
    typeLabel: { default: void 0 },
    isParent: { type: Boolean, default: !1 },
    onClick: { type: Function, default: () => {
    } },
    href: {},
    active: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["list-item-clicked", "list-item-selected"],
  setup(x, { emit: z }) {
    const k = z, s = T(), a = E(), o = v(), N = p(() => a.value), P = p(() => a.name), F = p(() => {
      if (u.size)
        return u.size;
      if (d.size === "small")
        return "tiny";
      if (d.size === "medium")
        return "small";
    }), l = x, u = S(K, {
      multiselect: ""
    }), t = S(Z, { isCustomSelectList: !1, isPreselectAction: !1, focusedValue: void 0, focusedIndex: 0 }), d = S(Q, {
      size: "small"
    }), m = v(l.active), c = v(l.active), C = v(!1), I = v();
    A(() => {
      t.updateCustomSelectFocus && o.value.addEventListener("keydown", (e) => g(e)), l.active && d.emitInstead && (V(), m.value = !1);
    }), M(() => {
      t.updateCustomSelectFocus && o.value && o.value.removeEventListener("keydown", (e) => g(e));
    }), b(
      () => t.focusedValue,
      (e) => {
        e === a.value && (C.value = e === t.focusedIndex);
      }
    ), b(
      () => t.focusedIndex,
      (e) => {
        I.value = e, C.value = o.value === o.value.parentNode.children[e], o.value === o.value.parentNode.children[e] && (o.value.focus(), t.updateCustomSelectFocus && t.updateCustomSelectFocus(a.value));
      }
    );
    function g(e) {
      var i;
      e.key === "Enter" && o.value === o.value.parentNode.children[I.value] && t.updateCustomSelectValue && (c.value = !c.value, m.value = !m.value, t.updateCustomSelectValue(
        {
          label: (i = s.default) == null ? void 0 : i.call(s)[0].children,
          value: a.value,
          key: a.key,
          icon: u.multiselect ? void 0 : l.leadingIcon,
          typeLabel: l.typeLabel
        },
        !c.value
      ));
    }
    b(
      () => t.isPreselectAction,
      (e) => {
        var i, r;
        e && ((i = t.activeValues) != null && i.includes(a.value)) && (c.value = !0, m.value = !0, t.updateCustomSelectValue && t.updateCustomSelectValue(
          {
            label: (r = s.default) == null ? void 0 : r.call(s)[0].children,
            value: a.value,
            key: a.key,
            icon: u.multiselect ? void 0 : l.leadingIcon,
            typeLabel: l.typeLabel
          },
          !1,
          !0
        ));
      }
    ), b(
      () => t.activeValues,
      (e, i) => {
        e.includes(a.value) || (m.value = !1);
      }
    );
    function _(e) {
      var i;
      e ? (k("list-item-clicked"), V()) : t.isCustomSelectList && t.updateCustomSelectValue ? (u.multiselect && (c.value = !c.value, k("list-item-selected", u.multiselect, a.value, c.value)), t.updateCustomSelectValue(
        {
          label: (i = s.default) == null ? void 0 : i.call(s)[0].children,
          value: a.value,
          key: a.key,
          icon: u.multiselect ? void 0 : l.leadingIcon,
          typeLabel: l.typeLabel
        },
        !c.value
      )) : (k("list-item-clicked"), l.onClick());
    }
    function w() {
      d.isClickedButtonDisabled && d.isClickedButtonDisabled(l.disabled);
    }
    function V() {
      var e;
      d.replace && d.replace(l.onClick, (e = s.default) == null ? void 0 : e.call(s)[0].children, Object.assign({ ...l }, { ...a }));
    }
    const D = p(
      () => W(
        l,
        u.multiselect,
        d.activeMethod,
        m.value,
        C.value,
        t.activeValues,
        a.value
      )
    );
    return (e, i) => {
      var r, B;
      return y(), L("li", {
        ref_key: "listItemRef",
        ref: o,
        class: U(D.value),
        onClick: w,
        tabindex: n(t).disableTabbing ? -1 : 0
      }, [
        $(Y, {
          variant: "text",
          tabindex: n(t).disableTabbing ? -1 : 0,
          disabled: l.disabled,
          size: F.value,
          "full-width": !0,
          "leading-icon": l.leadingIcon && !n(u).multiselect && !((r = n(u).multiselect) != null && r.trim()) ? l.leadingIcon : void 0,
          "trailing-icon": l.isParent && !l.typeLabel && !((B = l.typeLabel) != null && B.trim()) ? "chevronRight" : void 0,
          "o-icon-variant": n(u).size === "small" ? "small" : "normal",
          onClick: i[0] || (i[0] = (f) => _(n(d).emitInstead))
        }, {
          default: j(() => [
            O(e.$slots, "default")
          ]),
          _: 3
        }, 8, ["tabindex", "disabled", "size", "leading-icon", "trailing-icon", "o-icon-variant"]),
        n(u).multiselect ? (y(), q(X, {
          key: 0,
          modelValue: c.value,
          "onUpdate:modelValue": i[1] || (i[1] = (f) => c.value = f),
          tabindex: n(t).disableTabbing ? -1 : 0,
          name: n(u).multiselect.trim(),
          value: N.value
        }, null, 8, ["modelValue", "tabindex", "name", "value"])) : h("", !0),
        e.typeLabel && e.typeLabel.trim() ? (y(), L("span", te, G(e.typeLabel), 1)) : h("", !0),
        n(u) && !n(u).multiselect ? H((y(), L("input", {
          key: 2,
          type: "radio",
          tabindex: "-1",
          name: P.value,
          "onUpdate:modelValue": i[2] || (i[2] = (f) => m.value = f),
          value: n(a).value,
          style: { appearance: "none", width: 0, height: 0, overflow: "hidden" }
        }, null, 8, le)), [
          [J, m.value]
        ]) : h("", !0)
      ], 10, ee);
    };
  }
});
export {
  oe as default
};
